import * as React from 'react';
import { connect } from 'react-redux';

import TeamMembersList from '../../common/TeamMembersList/TeamMembersList';
import { MembersTableState, TeamMembersTableData } from '../../common/types';
import {
    QUERY_CHANGED,
    ROLE_FILTER_ADDED,
    ROLE_FILTER_REMOVED,
    SORT_TOGGLED,
    STATUS_FILTER_CHANGED,
    CLEAR_FILTERS, NAMES_AND_EMAILS_FILTER_CHANGED,
} from '../../redux/actions/action-types';
import { showModal } from '../../redux/actions/activeModal.actions';
import { showToast } from '../../redux/actions/activeToast.actions';
import {
    reportGetLinkClicked,
    reportOpenChangeRoles,
    reportOpenDeleteTeamMemberDialog,
    reportResendInviteClick,
    reportTeammatesPageFilterByStatus
} from '../../redux/actions/bi.actions';
import {
    cancelTransferOwnership,
    resendInvite,
    resendTransferOwnershipEmail
} from '../../redux/actions/serverApi.actions';
import { State } from '../../redux/configure-store';
import { getOwnerId, getTeamMembersList } from '../../redux/selectors/teamMembers';
import { getPermission } from '../../redux/selectors/teamDetails';
import { getRoleIds, getTable, getTableFilter } from '../../redux/selectors/table';
import { copyTextToClipboard } from '../../services/copyTextToClipboard';
import { InviteStatusType, PermissionKey } from '../../services/server-types';
import {
    convertTeamMembersDataToTableData,
    queryMembersTable,
    sortingTableMembers,
} from '../../services/team-table-data-convertor';
import { ModalName } from '../../types/ModalNames';
import { ToastName } from '../../types/ToastNames';
import { Role } from '../../types/roles';
import { isUserOwner } from '../../redux/selectors/teamDetails';
import { getManageRolesPermission } from '../../redux/selectors/teamDetails';
import { getRoles } from '../../redux/selectors/roles';

type MapStateToPropsOutput = {
    data: TeamMembersTableData;
    permissions: Set<string>;
    computedData: TeamMembersTableData;
    roleIds: string[];
    membersTableState: MembersTableState;
    currentUserId: string;
    currentAccountId?: string
    locale: string;
    roles: Role[];
    viewInvitesPermission: boolean;
    topology: any;
    msId?: string;
    isOwner: boolean;
    isAllowedToManageRoles: boolean;
    ownerId: string;
};

const mapStateToProps = (state: State): MapStateToPropsOutput => {
    const tableMembers = convertTeamMembersDataToTableData(getTeamMembersList(state));
    const roles = getRoles(state);
    const roleIds = getRoleIds(state, tableMembers);
    const membersTable = getTable(state);
    if (tableMembers.length > 0) {
        membersTable.filters.roles = getTableFilter(state, roleIds as string[]);
    }

    const computedData: TeamMembersTableData = queryMembersTable(tableMembers, membersTable, roleIds as string[]);

    return {
        currentUserId: state.teamDetails.userId,
        currentAccountId: state.teamDetails.loggedInAccountId,
        computedData: computedData.sort(sortingTableMembers(membersTable, state.teamDetails.userId, state)),
        data: tableMembers,
        roleIds,
        membersTableState: membersTable,
        permissions: state.teamDetails.permissions,
        locale: state.locale,
        roles,
        viewInvitesPermission: getPermission(state, PermissionKey.VIEW_INVITES),
        msId: state.msid,
        topology: state.topology,
        isOwner: isUserOwner(state),
        isAllowedToManageRoles: getManageRolesPermission(state),
        ownerId: getOwnerId(state),
    };
};

const mapDispatchToProps = (dispatch, ownProps) => ({
    onRemoveRequest: (id, isCurrentUser?) => {
        dispatch(reportOpenDeleteTeamMemberDialog(id));
        if (isCurrentUser) {
            dispatch(showModal(ModalName.LeaveTeam, { idToRemove: id }));
        } else {
            dispatch(showModal(ModalName.RemoveFromTeam, { idToRemove: id, isBizMgr: !!ownProps.msid }));
        }
    },
    onGetLink: (link: string, inviteId: string) => {
        copyTextToClipboard(link);
        dispatch(showToast(ToastName.LinkCopied, {}));
        dispatch(reportGetLinkClicked(inviteId));
    },
    onResendRequest: (id) => {
        dispatch(reportResendInviteClick(id));
        dispatch(resendInvite(id));
    },
    onRoleFilterAdded: (filter: string, filters: string[]) => {
        if (filter === 'all') {
            return dispatch({ type: ROLE_FILTER_ADDED, value: filters });
        }
        dispatch({ type: ROLE_FILTER_ADDED, value: filter });
    },
    onRoleFilterRemoved: (filter: string, filters: string[]) => {
        if (filter === 'all') {
            return dispatch({ type: ROLE_FILTER_REMOVED, value: filters });
        }
        dispatch({ type: ROLE_FILTER_REMOVED, value: filter });
    },
    onStatusFilterChanged: (status: InviteStatusType) => {
        dispatch({ type: STATUS_FILTER_CHANGED, value: status });
        dispatch(reportTeammatesPageFilterByStatus());
    },
    onQueryChanged: (query: string) => {
        dispatch({ type: QUERY_CHANGED, value: query });
    },
    onSortToggled: (column: string) => {
        dispatch({ type: SORT_TOGGLED, value: column });
    },
    onClearFilters: () => {
      dispatch({ type: CLEAR_FILTERS });
    },
    onNamesAndEmailsFilterChanged: (e) => {
      dispatch( { type: NAMES_AND_EMAILS_FILTER_CHANGED, value: e.target.value });
    },
    onResendTransferOwnership: () => {
      dispatch(resendTransferOwnershipEmail());
    },
    onCancelTransferOwnership: () => {
      dispatch(cancelTransferOwnership());
    },
    onGetTransferOwnershipLink: () => {
        copyTextToClipboard(ownProps.transferOwnershipLink);
        dispatch(showToast(ToastName.TransferOwnershipLinkCopied, {}));
    },
    reportOpenChangeRolesBI: (id) => dispatch(reportOpenChangeRoles(id)),
});

export const connector = connect(mapStateToProps, mapDispatchToProps);
export default connector(TeamMembersList);
